'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.preprocessElementData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


var _elementHelper = require('../../../../common/elements/elementHelper');

var _adjustElementType = require('../../../../common/documentOrder/adjustElementType');

var _adjustElementType2 = _interopRequireDefault(_adjustElementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adjustBoardPosition = function adjustBoardPosition(documentModeDetails) {
    return _extends({}, documentModeDetails, {
        x: documentModeDetails.x - 2,
        y: documentModeDetails.y - 1,
        width: documentModeDetails.width + 4,
        height: documentModeDetails.height + 1
    });
};

var preprocessElementData = exports.preprocessElementData = function preprocessElementData(elements, elementSizes) {
    return elementSizes.map(function (elementSizeDetails) {
        var element = elements.get(elementSizeDetails.id);
        var position = element.getIn(['location', 'position']).toJS();

        var documentModeDetails = _extends({
            x: position.x,
            y: position.y
        }, elementSizeDetails, {
            elementType: (0, _adjustElementType2.default)(element.get('elementType')),
            color: element.getIn(['content', 'color'])
        });

        if ((0, _elementHelper.isBoardLike)(documentModeDetails.elementType)) {
            documentModeDetails = adjustBoardPosition(documentModeDetails);
        }

        return documentModeDetails;
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/algorithm/elementDataPreprocessor.js
// module id = 2207
// module chunks = 0